import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useAgenciesList() {
  // Use toast
  const toast = useToast()

  const refAgencyListTable = ref(null)

  // Table Handlers
  const tableColumns = [

    { key: 'company', label: 'Ragione Sociale', sortable: true },
    { key: 'provvigioniConfigurate', label: '' },
    { key: 'name', label: 'Nome', sortable: true },
    { key: 'contact', label: 'Contatto', sortable: true },
    { key: 'address', label: 'Indirizzo', sortable: true },
    { key: 'actions', label: 'Azioni' },
  ]
  const perPage = ref(10)
  const totalAgencies = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('Id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refAgencyListTable.value ? refAgencyListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalAgencies.value,
    }
  })

  const refetchData = () => {
    refAgencyListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchAgencies = (ctx, callback) => {
    store
      .dispatch('app-agency/fetchAgencies', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { agencies, total } = response.data

        callback(agencies)
        totalAgencies.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching agencies' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  return {
    fetchAgencies,
    tableColumns,
    perPage,
    currentPage,
    totalAgencies,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refAgencyListTable,

    refetchData,
  }
}
